import styled from '@emotion/styled';
import { Typography } from '../../../../components-dummy';

export const SubTitleStyled = styled(Typography)`
  display: block;
  margin-bottom: 16px;
`;
